"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputType = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Search_1 = __importDefault(require("../Icons/Search/Search"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var Typography_1 = __importStar(require("../Typography/Typography"));
var InputType;
(function (InputType) {
    InputType["search"] = "search";
    InputType["text"] = "text";
})(InputType = exports.InputType || (exports.InputType = {}));
var InputContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n"], ["\n  position: relative;\n  overflow: hidden;\n"])));
var LabelElement = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  left: 2.6rem;\n  top: 1.7rem;\n  font-size: 1.2rem;\n  text-transform: uppercase;\n\n  color: ", ";\n"], ["\n  position: absolute;\n  left: 2.6rem;\n  top: 1.7rem;\n  font-size: 1.2rem;\n  text-transform: uppercase;\n\n  color: ", ";\n"])), function (_a) {
    var invalid = _a.invalid;
    return invalid ? b2c_theme_1.colors.input.invalid : b2c_theme_1.colors.labelFontColor;
});
var SearchIcon = (0, styled_components_1.default)(Search_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  right: 1.5rem;\n  top: 3.4rem;\n  user-select: none;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  right: 1.5rem;\n  top: 3.4rem;\n  user-select: none;\n  pointer-events: none;\n"])));
var InputElement = styled_components_1.default.input(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: 1.6rem;\n  color: ", ";\n  line-height: 2.2.rem;\n  width: 100%;\n  appearance: none;\n  border-width: 2px;\n  border-style: solid;\n  padding: 3.5rem\n    ", " 2.2rem\n    2.4rem;\n  background: ", ";\n  outline: 0;\n  ", "\n\n  border-color: ", ";\n\n  &::placeholder {\n    color: ", ";\n    opacity: ", ";\n  }\n\n  &::-webkit-search-cancel-button {\n    display: none;\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"], ["\n  font-family: ", ";\n  font-size: 1.6rem;\n  color: ", ";\n  line-height: 2.2.rem;\n  width: 100%;\n  appearance: none;\n  border-width: 2px;\n  border-style: solid;\n  padding: 3.5rem\n    ", " 2.2rem\n    2.4rem;\n  background: ", ";\n  outline: 0;\n  ", "\n\n  border-color: ", ";\n\n  &::placeholder {\n    color: ", ";\n    opacity: ", ";\n  }\n\n  &::-webkit-search-cancel-button {\n    display: none;\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"])), b2c_theme_1.fonts.default, b2c_theme_1.colors.primaryFontColor, function (_a) {
    var type = _a.type;
    return (type === InputType.search ? '3.2rem' : '2.4rem');
}, b2c_theme_1.colors.input.background, function (_a) {
    var disabled = _a.disabled;
    return disabled
        ? (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          opacity: 0.6;\n          cursor: not-allowed;\n\n          & ~ ", " {\n            opacity: 0.3;\n          }\n        "], ["\n          opacity: 0.6;\n          cursor: not-allowed;\n\n          & ~ ", " {\n            opacity: 0.3;\n          }\n        "])), SearchIcon) : (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          opacity: 1;\n        "], ["\n          opacity: 1;\n        "])));
}, function (_a) {
    var invalid = _a.invalid;
    return invalid ? b2c_theme_1.colors.input.invalid : b2c_theme_1.colors.input.background;
}, b2c_theme_1.colors.primaryLightFontColor, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '0.6' : '1');
}, b2c_theme_1.colors.input.focus);
var ErrorContainer = styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  left: 2.6rem;\n  bottom: 0;\n  white-space: nowrap;\n  overflow-y: scroll;\n  width: calc(100% - 3.5rem);\n"], ["\n  position: absolute;\n  left: 2.6rem;\n  bottom: 0;\n  white-space: nowrap;\n  overflow-y: scroll;\n  width: calc(100% - 3.5rem);\n"])));
var Input = react_1.default.forwardRef(function (props, ref) {
    var defaultProps = {
        disabled: false,
        invalid: false,
        required: false,
        type: InputType.text,
    };
    var _a = __assign(__assign({}, defaultProps), props), disabled = _a.disabled, errors = _a.errors, id = _a.id, invalid = _a.invalid, label = _a.label, name = _a.name, placeholder = _a.placeholder, required = _a.required, type = _a.type, rest = __rest(_a, ["disabled", "errors", "id", "invalid", "label", "name", "placeholder", "required", "type"]);
    return (react_1.default.createElement(InputContainer, null,
        react_1.default.createElement(LabelElement, { htmlFor: id, invalid: invalid, "data-testid": "input-label-element" },
            label,
            required ? (react_1.default.createElement(Typography_1.default, { component: Typography_1.TypeVariants.span, variant: Typography_1.TypeVariants.bodySmall, theme: "invalid", style: { lineHeight: 1 } }, "\u00A0*\u00A0")) : null),
        react_1.default.createElement(InputElement, __assign({ "aria-invalid": invalid, "aria-describedby": (errors === null || errors === void 0 ? void 0 : errors.length) ? "err_".concat(id) : undefined, "data-testid": "input-element", disabled: disabled, id: id, invalid: invalid, name: name, placeholder: placeholder, ref: ref, required: required, type: type }, rest)),
        type === InputType.search ? react_1.default.createElement(SearchIcon, { focusable: "false" }) : null,
        react_1.default.createElement(ErrorContainer, { id: "err_".concat(id), "data-testid": "input-error-container-element" }, (errors === null || errors === void 0 ? void 0 : errors.length) ? (react_1.default.createElement(Typography_1.default, { "data-testid": "input-error-element", variant: Typography_1.TypeVariants.body, component: Typography_1.TypeVariants.span, style: { paddingRight: '1rem' }, theme: "invalid" }, errors.join(', '))) : null)));
});
exports.default = Input;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=Input.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Input/Input.js
// module id = 1440
// module chunks = 1 5 6 7 9 14 15 18 29 42 80